import { render, staticRenderFns } from "./PNumber.vue?vue&type=template&id=5092182a"
import script from "./PNumber.vue?vue&type=script&lang=js"
export * from "./PNumber.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports